<div class="ui-drop-area"
  [class.is-dragging]="isDragging && dragAllowed"
  (dragenter)="dragenterHandler($event)"
  (dragover)="dragoverHandler($event)"
  (dragleave)="dragleaveHandler($event)"
  (drop)="dropHandler($event)">
  <ng-content></ng-content>
</div>
